// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3u2wT","left":"styles_left__1tFJU"};